import React, { createContext, useState, useContext, useCallback } from 'react';
import axios from 'axios';

// 1. Context 생성: 전역 상태를 담을 공간
const AuthContext = createContext(null);

// 2. Provider 컴포넌트 생성: Context를 구독하는 자식들에게 상태와 함수들을 제공
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const isLoggedIn = !!user; // user 객체가 있으면 true, 없으면 false

    // 로그인 함수
    const login = useCallback(async (username, password) => {
        const formData = new FormData();
        formData.append('id', username);
        formData.append('passwd', password);

        try {
            const response = await axios.post('/api/login', formData);
            if (response.data?.list?.[0]?.login_chk === "1") {
                const userData = response.data.list[0];
                setUser(userData); // 로그인 성공 시 사용자 정보 저장
                return { success: true, user: userData };
            } else {
                const message = response.data?.message || '아이디 또는 비밀번호가 올바르지 않습니다.';
                return { success: false, error: message };
            }
        } catch (err) {
            const message = err.response?.data?.message || '로그인 중 오류가 발생했습니다.';
            return { success: false, error: message };
        }
    }, []);

    // 로그아웃 함수
    const logout = useCallback(() => {
        setUser(null);
        // 필요하다면 여기에 로그아웃 API 호출 로직 추가
    }, []);

    // Provider가 제공할 값들
    const value = {
        user,
        isLoggedIn,
        login,
        logout,
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

// 3. Custom Hook 생성: 컴포넌트에서 쉽게 Context를 사용하기 위함
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth는 AuthProvider 안에서 사용해야 합니다.');
    }
    return context;
};